import { render, staticRenderFns } from "./p2.vue?vue&type=template&id=0066590d&scoped=true"
import script from "./p2.vue?vue&type=script&lang=js"
export * from "./p2.vue?vue&type=script&lang=js"
import style0 from "./p2.vue?vue&type=style&index=0&id=0066590d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0066590d",
  null
  
)

export default component.exports